import React, { createContext, Dispatch, SetStateAction } from 'react';

export interface IEditPickupPersonContext {
  openPickupPersonDrawer: boolean;
  setOpenPickupPersonDrawer: Dispatch<SetStateAction<boolean>>;
}

type IEditPickupPersonProvider = {
  children: React.ReactNode;
};

export const EditPickupPersonContext = createContext<IEditPickupPersonContext>({
  openPickupPersonDrawer: false,
  setOpenPickupPersonDrawer: () => null,
});

export function EditPickupPersonProvider({
  children,
}: IEditPickupPersonProvider) {
  const [openPickupPersonDrawer, setOpenPickupPersonDrawer] =
    React.useState<boolean>(false);

  return (
    <EditPickupPersonContext.Provider
      value={{ openPickupPersonDrawer, setOpenPickupPersonDrawer }}
    >
      {children}
    </EditPickupPersonContext.Provider>
  );
}
